import {UseEntityData} from "crqlar-react-common/dist/components/useEntity";
import {SimphonyConfig} from "crqlar-react-common/dist/models/integrations/simphony/simphony.config";
import ImportLogsTable from "../../common/ImportLogsTable";

interface Props {
    configData: UseEntityData<SimphonyConfig>
}

const Logs = ({configData}: Props) => (
    <ImportLogsTable
        configId={configData.item.id}
        tableId="system-simphony-import-logs"
    />
);

export default Logs;
